import axios, { type AxiosError } from "axios";

export const getErrorMessage = (error: Error | AxiosError): string => {
  if (axios.isAxiosError(error)) {
    const resp = error.response?.data;
    return resp?.debug || resp?.message || error?.message;
  }
  return error.message;
};
